import Rest from '../rest'
import store from "@/store"

let controller = new AbortController()
export default class DataTable extends Rest {

    /**
     * @param {String} resource 
     */
    constructor (resource, datatable, httpId = 'http', columns = []) {
        super(resource)
        this.datatable = datatable
        this.columns = columns
        this.httpId = httpId
        this.abort = this.abort.bind(this)
        document.addEventListener('abortInPluginAxios', () => this.abort)
        this.prototypes = function () {
            const data = {
                draw: 1,
                order: [{
                    column: 0,
                    dir: 'asc'
                }],
                start: 0,
                length: 25,
                search: {
                    value: null,
                    regex: false
                },
                columns: []
            }
        
            const column = (
                data = "",
                name = "",
                searchable = false,
                orderable = false,
                search = { value: "", regex: false }
            ) => ({
                data,
                name,
                searchable,
                orderable,
                search
            })

            return { data, column }
        }()
    }
    abort(val) {
        if(val) {
            store.dispatch('app/setDatatableCancel', val)
        }
        controller.abort()
        controller = new AbortController()
        document.removeEventListener('abortInPluginAxios', () => this.abort);
    }

    /**
     * Monta uma requisição de datatable com os dados vindos de um
     * formulário
     * 
     * @param {*} data 
     */
    async dataTable(data) {
        let params = { ...this.prototypes.data }
        params.columns = [ ...this.columns ]

        for (let column in data) {
            switch (column) {
                case 'sortBy':
                    if (typeof data[column] === 'object') {
                        const index = this.columns.findIndex((el) => (el.data == data[column].value || el.name == data[column].value))
                        params.order[0].column = index > 0 ? index : 0
                        params.order[0].dir = data[column].dir || params.order[0].dir

                    } else {
                        const index = this.columns.findIndex((el) => el.data == data[column])
                        params.order[0].column = index > 0 ? index : 0
                    }
                    break

                case 'search':
                    params.search.value = data[column] == undefined ? '' : data[column]
                    break

                case 'page':
                    var length = data['perPage'] || params.length
                    params.start = (data[column] - 1) * length
                    break

                case 'perPage':
                    params.length = data[column]
                    break

                case 'filter':
                    if (typeof data[column] !== 'object') throw new Error('The filter data to datatable param must be a Object')
                    for (let item of data[column]) {
                        var index = this.columns.findIndex((el) => el.data == item.name)
                        if (index < 0) throw new Error('The filter parameter configuration was not found in the service')

                        /** Caso o valor do filtro seja um array, converte este em uma String antes de atribuir ao DataTable */
                        if (item.value &&
                            typeof item.value === 'object' &&
                            Object.prototype.hasOwnProperty.call(item.value, 'length')) {
                            /** Caso o filtro utilize regex */
                            if (params.columns[index].search.regex || item.name == 'team_name' || item.name == 'team_id') {
                                params.columns[index].search.value = item.value.map(value => `^${value}$`).join(',') || ''

                            } else {
                                params.columns[index].search.value = item.value.join(',') || ''
                            }

                        } else {
                            /** Caso o filtro utilize regex */
                            if (params.columns[index].search.regex || item.name == 'team_name' || item.name == 'team_id') {
                                params.columns[index].search.value = item.value ? `^${item.value}$` : ''

                            } else {
                                params.columns[index].search.value = item.value || ''
                            }
                        }
                    }
                    break
            }
        }
        return await this[this.httpId].post(this.constructor.normalize('datatable/', this.datatable),
            params,
            {
                signal: controller.signal
            }
        )
    }
}